import {
  getFirmwareList,
  getFirmwareReleases,
  getFirmwareReleasesById,
  getFirmwareUploadFiles,
  getFirmwareUploadDocuments,
  getFirmwarePrefixes,
  getFirmwareTypes,
  deleteRelease,
  deleteFirmwareFile,
  deleteFirmwareDocument,
  postRelease,
  putRelease,
  patchFirmwareFile,
  patchFirmwareDocument,
  getUserProductsFirmwareUpdateStatus,
} from '../utils/requests/firmwareAPI'
import { getFirmwareDownloadModels } from '../utils/requests/productsAPI'

export const LOAD_FIRMWARE_DOWNLOAD = 'LOAD_FIRMWARE_DOWNLOAD'
export const LOAD_FIRMWARE_DOWNLOAD_PENDING = 'LOAD_FIRMWARE_DOWNLOAD_PENDING'
export const LOAD_FIRMWARE_DOWNLOAD_FULFILLED = 'LOAD_FIRMWARE_DOWNLOAD_FULFILLED'
export const LOAD_FIRMWARE_DOWNLOAD_REJECTED = 'LOAD_FIRMWARE_DOWNLOAD_REJECTED'

export const LOAD_FIRMWARE_RELEASES = 'LOAD_FIRMWARE_RELEASES'
export const LOAD_FIRMWARE_RELEASES_PENDING = 'LOAD_FIRMWARE_RELEASES_PENDING'
export const LOAD_FIRMWARE_RELEASES_FULFILLED = 'LOAD_FIRMWARE_RELEASES_FULFILLED'
export const LOAD_FIRMWARE_RELEASES_REJECTED = 'LOAD_FIRMWARE_RELEASES_REJECTED'

export const LOAD_NEW_FIRMWARE_RELEASES = 'LOAD_NEW_FIRMWARE_RELEASES'
export const LOAD_NEW_FIRMWARE_RELEASES_PENDING = 'LOAD_NEW_FIRMWARE_RELEASES_PENDING'
export const LOAD_NEW_FIRMWARE_RELEASES_FULFILLED = 'LOAD_NEW_FIRMWARE_RELEASES_FULFILLED'
export const LOAD_NEW_FIRMWARE_RELEASES_REJECTED = 'LOAD_NEW_FIRMWARE_RELEASES_REJECTED'

export const LOAD_FIRMWARE_RELEASE_DETAILS = 'LOAD_FIRMWARE_RELEASE_DETAILS'
export const LOAD_FIRMWARE_RELEASE_DETAILS_PENDING = 'LOAD_FIRMWARE_RELEASE_DETAILS_PENDING'
export const LOAD_FIRMWARE_RELEASE_DETAILS_FULFILLED = 'LOAD_FIRMWARE_RELEASE_DETAILS_FULFILLED'
export const LOAD_FIRMWARE_RELEASE_DETAILS_REJECTED = 'LOAD_FIRMWARE_RELEASE_DETAILS_REJECTED'

export const LOAD_FIRMWARE_UPLOAD_FILES = 'LOAD_FIRMWARE_UPLOAD_FILES'
export const LOAD_FIRMWARE_UPLOAD_FILES_PENDING = 'LOAD_FIRMWARE_UPLOAD_FILES_PENDING'
export const LOAD_FIRMWARE_UPLOAD_FILES_FULFILLED = 'LOAD_FIRMWARE_UPLOAD_FILES_FULFILLED'
export const LOAD_FIRMWARE_UPLOAD_FILES_REJECTED = 'LOAD_FIRMWARE_UPLOAD_FILES_REJECTED'

export const LOAD_NEW_FIRMWARE_UPLOAD_FILES = 'LOAD_NEW_FIRMWARE_UPLOAD_FILES'
export const LOAD_NEW_FIRMWARE_UPLOAD_FILES_PENDING = 'LOAD_NEW_FIRMWARE_UPLOAD_FILES_PENDING'
export const LOAD_NEW_FIRMWARE_UPLOAD_FILES_FULFILLED = 'LOAD_NEW_FIRMWARE_UPLOAD_FILES_FULFILLED'
export const LOAD_NEW_FIRMWARE_UPLOAD_FILES_REJECTED = 'LOAD_NEW_FIRMWARE_UPLOAD_FILES_REJECTED'

export const LOAD_FIRMWARE_UPLOAD_DOCUMENTS = 'LOAD_FIRMWARE_UPLOAD_DOCUMENTS'
export const LOAD_FIRMWARE_UPLOAD_DOCUMENTS_PENDING = 'LOAD_FIRMWARE_UPLOAD_DOCUMENTS_PENDING'
export const LOAD_FIRMWARE_UPLOAD_DOCUMENTS_FULFILLED = 'LOAD_FIRMWARE_UPLOAD_DOCUMENTS_FULFILLED'
export const LOAD_FIRMWARE_UPLOAD_DOCUMENTS_REJECTED = 'LOAD_FIRMWARE_UPLOAD_DOCUMENTS_REJECTED'

export const LOAD_NEW_FIRMWARE_UPLOAD_DOCUMENTS = 'LOAD_NEW_FIRMWARE_UPLOAD_DOCUMENTS'
export const LOAD_NEW_FIRMWARE_UPLOAD_DOCUMENTS_PENDING = 'LOAD_NEW_FIRMWARE_UPLOAD_DOCUMENTS_PENDING'
export const LOAD_NEW_FIRMWARE_UPLOAD_DOCUMENTS_FULFILLED = 'LOAD_NEW_FIRMWARE_UPLOAD_DOCUMENTS_FULFILLED'
export const LOAD_NEW_FIRMWARE_UPLOAD_DOCUMENTS_REJECTED = 'LOAD_NEW_FIRMWARE_UPLOAD_DOCUMENTS_REJECTED'

export const LOAD_FIRMWARE_TYPES = 'LOAD_FIRMWARE_TYPES'
export const LOAD_FIRMWARE_TYPES_PENDING = 'LOAD_FIRMWARE_TYPES_PENDING'
export const LOAD_FIRMWARE_TYPES_FULFILLED = 'LOAD_FIRMWARE_TYPES_FULFILLED'
export const LOAD_FIRMWARE_TYPES_REJECTED = 'LOAD_FIRMWARE_TYPES_REJECTED'

export const LOAD_FIRMWARE_PREFIXES = 'LOAD_FIRMWARE_PREFIXES'
export const LOAD_FIRMWARE_PREFIXES_PENDING = 'LOAD_FIRMWARE_PREFIXES_PENDING'
export const LOAD_FIRMWARE_PREFIXES_FULFILLED = 'LOAD_FIRMWARE_PREFIXES_FULFILLED'
export const LOAD_FIRMWARE_PREFIXES_REJECTED = 'LOAD_FIRMWARE_PREFIXES_REJECTED'

export const LOAD_FIRMWARE_UPDATE_AVAILABLE_STATUS = 'LOAD_FIRMWARE_UPDATE_AVAILABLE_STATUS'
export const LOAD_FIRMWARE_UPDATE_AVAILABLE_STATUS_PENDING = 'LOAD_FIRMWARE_UPDATE_AVAILABLE_STATUS_PENDING'
export const LOAD_FIRMWARE_UPDATE_AVAILABLE_STATUS_FULFILLED = 'LOAD_FIRMWARE_UPDATE_AVAILABLE_STATUS_FULFILLED'
export const LOAD_FIRMWARE_UPDATE_AVAILABLE_STATUS_REJECTED = 'LOAD_FIRMWARE_UPDATE_AVAILABLE_STATUS_REJECTED'

export const POST_RELEASE = 'POST_RELEASE'
export const POST_RELEASE_PENDING = 'POST_RELEASE_PENDING'
export const POST_RELEASE_FULFILLED = 'POST_RELEASE_FULFILLED'
export const POST_RELEASE_REJECTED = 'POST_RELEASE_REJECTED'

export const PUT_RELEASE = 'PUT_RELEASE'
export const PUT_RELEASE_PENDING = 'PUT_RELEASE_PENDING'
export const PUT_RELEASE_FULFILLED = 'PUT_RELEASE_FULFILLED'
export const PUT_RELEASE_REJECTED = 'PUT_RELEASE_REJECTED'

export const PATCH_FIRMWARE_FILE = 'PATCH_FIRMWARE_FILE'
export const PATCH_FIRMWARE_FILE_PENDING = 'PATCH_FIRMWARE_FILE_PENDING'
export const PATCH_FIRMWARE_FILE_FULFILLED = 'PATCH_FIRMWARE_FILE_FULFILLED'
export const PATCH_FIRMWARE_FILE_REJECTED = 'PATCH_FIRMWARE_FILE_REJECTED'

export const PATCH_FIRMWARE_DOCUMENT = 'PATCH_FIRMWARE_DOCUMENT'
export const PATCH_FIRMWARE_DOCUMENT_PENDING = 'PATCH_FIRMWARE_DOCUMENT_PENDING'
export const PATCH_FIRMWARE_DOCUMENT_FULFILLED = 'PATCH_FIRMWARE_DOCUMENT_FULFILLED'
export const PATCH_FIRMWARE_DOCUMENT_REJECTED = 'PATCH_FIRMWARE_DOCUMENT_REJECTED'

export const DELETE_RELEASE = 'DELETE_RELEASE'
export const DELETE_RELEASE_PENDING = 'DELETE_RELEASE_PENDING'
export const DELETE_RELEASE_FULFILLED = 'DELETE_RELEASE_FULFILLED'
export const DELETE_RELEASE_REJECTED = 'DELETE_RELEASE_REJECTED'

export const DELETE_FIRMWARE_FILE = 'DELETE_FIRMWARE_FILE'
export const DELETE_FIRMWARE_FILE_PENDING = 'DELETE_FIRMWARE_FILE_PENDING'
export const DELETE_FIRMWARE_FILE_FULFILLED = 'DELETE_FIRMWARE_FILE_FULFILLED'
export const DELETE_FIRMWARE_FILE_REJECTED = 'DELETE_FIRMWARE_FILE_REJECTED'

export const DELETE_FIRMWARE_DOCUMENT = 'DELETE_FIRMWARE_DOCUMENT'
export const DELETE_FIRMWARE_DOCUMENT_PENDING = 'DELETE_FIRMWARE_DOCUMENT_PENDING'
export const DELETE_FIRMWARE_DOCUMENT_FULFILLED = 'DELETE_FIRMWARE_DOCUMENT_FULFILLED'
export const DELETE_FIRMWARE_DOCUMENT_REJECTED = 'DELETE_FIRMWARE_DOCUMENT_REJECTED'

export const LOAD_FIRMWARE_MODELS = 'LOAD_FIRMWARE_MODELS'
export const LOAD_FIRMWARE_MODELS_PENDING = 'LOAD_FIRMWARE_MODELS_PENDING'
export const LOAD_FIRMWARE_MODELS_FULFILLED = 'LOAD_FIRMWARE_MODELS_FULFILLED'
export const LOAD_FIRMWARE_MODELS_REJECTED = 'LOAD_FIRMWARE_MODELS_REJECTED'

export const CLEAR_RELEASE_DETAILS = 'CLEAR_RELEASE_DETAILS'
export const CLEAR_FIRMWARE_MESSAGES = 'CLEAR_FIRMWARE_MESSAGES'

export function loadFirmwareModels() {
  return {
    type: LOAD_FIRMWARE_MODELS,
    payload: getFirmwareDownloadModels(),
  }
}

export function loadFirmwareDownload() {
  return {
    type: LOAD_FIRMWARE_DOWNLOAD,
    payload: getFirmwareList(),
  }
}

export function loadFirmwareReleases(queryParams, refetch = false) {
  return {
    type: refetch ? LOAD_NEW_FIRMWARE_RELEASES : LOAD_FIRMWARE_RELEASES,
    payload: getFirmwareReleases(queryParams),
  }
}

export function loadFirmwareUploadFiles(queryParams, refetch = false) {
  return {
    type: refetch ? LOAD_NEW_FIRMWARE_UPLOAD_FILES : LOAD_FIRMWARE_UPLOAD_FILES,
    payload: getFirmwareUploadFiles(queryParams),
  }
}

export function loadFirmwareUploadDocuments(queryParams, refetch = false) {
  return {
    type: refetch ? LOAD_NEW_FIRMWARE_UPLOAD_DOCUMENTS : LOAD_FIRMWARE_UPLOAD_DOCUMENTS,
    payload: getFirmwareUploadDocuments(queryParams),
  }
}

export function loadFirmwareReleaseDetails(id) {
  return {
    type: LOAD_FIRMWARE_RELEASE_DETAILS,
    payload: getFirmwareReleasesById(id),
  }
}

export function loadFirmwareTypes() {
  return {
    type: LOAD_FIRMWARE_TYPES,
    payload: getFirmwareTypes(),
  }
}

export function loadFirmwarePrefixes() {
  return {
    type: LOAD_FIRMWARE_PREFIXES,
    payload: getFirmwarePrefixes(),
  }
}

export function loadFirmwareUpdateAvailable(userUuid) {
  return {
    type: LOAD_FIRMWARE_UPDATE_AVAILABLE_STATUS,
    payload: getUserProductsFirmwareUpdateStatus(userUuid),
  }
}

export function createRelease(bodyParams) {
  return {
    type: POST_RELEASE,
    payload: postRelease(bodyParams),
  }
}

export function updateRelease(releaseId, bodyParams) {
  return {
    type: PUT_RELEASE,
    payload: putRelease(releaseId, bodyParams),
  }
}

export function updateFirmwareFile(fileId, bodyParams, releaseId) {
  return {
    type: PATCH_FIRMWARE_FILE,
    payload: patchFirmwareFile(fileId, bodyParams),
    meta: { fileId, releaseId },
  }
}

export function updateFirmwareDocument(fileId, bodyParams, releaseId) {
  return {
    type: PATCH_FIRMWARE_DOCUMENT,
    payload: patchFirmwareDocument(fileId, bodyParams),
    meta: { fileId, releaseId },
  }
}

export function removeRelease(releaseId) {
  return {
    type: DELETE_RELEASE,
    payload: deleteRelease(releaseId),
    meta: { releaseId },
  }
}

export function removeFirmwareFile(fileId, releaseId) {
  return {
    type: DELETE_FIRMWARE_FILE,
    payload: deleteFirmwareFile(fileId),
    meta: { fileId, releaseId },
  }
}

export function removeFirmwareDocument(fileId, releaseId) {
  return {
    type: DELETE_FIRMWARE_DOCUMENT,
    payload: deleteFirmwareDocument(fileId),
    meta: { fileId, releaseId },
  }
}

export function clearReleaseDetails() {
  return {
    type: CLEAR_RELEASE_DETAILS,
  }
}

export function clearFirmwareMessages() {
  return {
    type: CLEAR_FIRMWARE_MESSAGES,
  }
}

